// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refereeDeclinedPage button {
  float: none;
  margin-top: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/refereeDeclined/RefereeDeclined.less"],"names":[],"mappings":"AAAA;EAEE,WAAA;EACA,gBAAA;AAAF","sourcesContent":[".refereeDeclinedPage {\n\tbutton {\n\t\tfloat: none;\n\t\tmargin-top: 14px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
